/* Fit finder: height/weight -> size recommendation from the merchant's
   chart string ("S:158-172:48-68;M:166-180:60-80;..."). Pure client-side,
   no requests. When two sizes match, the larger one wins (house rule). */
(function () {
  document.querySelectorAll('[data-kso-fit]').forEach(function (root) {
    var chart = (root.dataset.chart || '')
      .split(';')
      .map(function (row) {
        var p = row.split(':');
        if (p.length !== 3) return null;
        var h = p[1].split('-').map(Number);
        var w = p[2].split('-').map(Number);
        return { size: p[0].trim(), h1: h[0], h2: h[1], w1: w[0], w2: w[1] };
      })
      .filter(Boolean);
    if (!chart.length) return;

    var result = root.querySelector('[data-kso-fit-result]');
    root.querySelector('button').addEventListener('click', function () {
      var h = parseFloat(root.querySelector('[name="kso-height"]').value);
      var w = parseFloat(root.querySelector('[name="kso-weight"]').value);
      if (!h || !w) {
        result.textContent = root.dataset.msgIncomplete;
        return;
      }
      var matches = chart.filter(function (r) {
        return h >= r.h1 && h <= r.h2 && w >= r.w1 && w <= r.w2;
      });
      if (!matches.length) {
        matches = chart.filter(function (r) {
          return (h >= r.h1 && h <= r.h2) || (w >= r.w1 && w <= r.w2);
        });
      }
      if (!matches.length) {
        result.textContent = root.dataset.msgNone;
        return;
      }
      var pick = matches[matches.length - 1];
      result.innerHTML = '';
      var label = document.createElement('span');
      label.textContent = root.dataset.msgResult + ' ';
      var size = document.createElement('span');
      size.className = 'kso-fit__size';
      size.textContent = pick.size;
      var note = document.createElement('small');
      note.textContent = ' — ' + root.dataset.msgNote;
      result.appendChild(label);
      result.appendChild(size);
      result.appendChild(note);
    });
  });
})();
